import React, { Fragment } from 'react';
import GooglePlay from '../../../theme/leap/dist/assets/img/icons/social/googleplay.svg';
import Apple from '../../../theme/leap/dist/assets/img/icons/social/apple.svg';

export default function SharePage({ links, ...props }) {
  let appleLink = links.find(({ link }) => link.linkStyle === 'app-store');
  let googleLink = links.find(({ link }) => link.linkStyle === 'g-play');
  return (
    <div className="d-sm-flex justify-content-center" {...props}>
      <a href={appleLink.link.linkUrl} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-secondary mx-sm-2 mb-3 mb-sm-0">
        <Apple className="injected-svg icon" />
        <span>{appleLink.link.linkText}</span>
      </a>
      <a href={googleLink.link.linkUrl} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-secondary mx-sm-2 mb-3 mb-sm-0">
        <GooglePlay className="injected-svg icon" />
        <span>{googleLink.link.linkText}</span>
      </a >
    </div >
  );
}